// NDA Mathematics Mock Exam Questions
// Extracted from Jay Defence Academy Dharwad Question Papers

export const ndaMathsSet1 = [
  {
    id: 1,
    question: "In how many ways can the letters of word 'INSURANCE' be arranged, such that the vowels are never separated?",
    options: ["360", "972", "8640", "17280"],
    correctAnswer: 2,
    category: "Permutations & Combinations"
  },
  {
    id: 2,
    question: "Find the area of the largest rectangle having the perimeter of 400 metres.",
    options: ["1000 sq. metres", "40000 sq. metres", "1600 sq. metres", "10000 sq. metres"],
    correctAnswer: 3,
    category: "Applications of Derivatives"
  },
  {
    id: 3,
    question: "Three houses are available in a locality. Three persons apply for the houses. Each applies for one house without consulting others. The probability that all three apply for the same house is:",
    options: ["7/9", "8/9", "1/9", "2/9"],
    correctAnswer: 2,
    category: "Probability"
  },
  {
    id: 4,
    question: "How many terms are there in the GP 5, 20, 80, 320, ..., 5120?",
    options: ["7", "6", "8", "9"],
    correctAnswer: 1,
    category: "Sequences & Series"
  },
  {
    id: 5,
    question: "If a kite is flying at a height of 40√3 m from the level ground, attached to a string inclined at 60° to the horizontal, then the length of the string is:",
    options: ["80 m", "60√3 m", "80√3 m", "120 m"],
    correctAnswer: 0,
    category: "Heights & Distances"
  },
  {
    id: 6,
    question: "The eccentricity of a hyperbola can never be equal to:",
    options: ["3", "2", "1/2", "√2"],
    correctAnswer: 2,
    category: "Conic Sections"
  },
  {
    id: 7,
    question: "If A and B are two matrices such that (A+B) and (A-B) are both defined, then A and B are:",
    options: ["Both null matrices", "Both identity matrices", "Both square matrices of same order", "None"],
    correctAnswer: 2,
    category: "Matrices"
  },
  {
    id: 8,
    question: "Let the positive numbers a, b, c, d be in A.P. Then abc, abd, acd, bcd are:",
    options: ["Not in A.P./G.P./H.P.", "In A.P.", "In G.P.", "In H.P."],
    correctAnswer: 3,
    category: "Sequences & Series"
  },
  {
    id: 9,
    question: "cos 35° + cos 85° + cos 155° =",
    options: ["1", "0", "1/2", "2"],
    correctAnswer: 1,
    category: "Trigonometry"
  },
  {
    id: 10,
    question: "What is the sum of first 50 natural numbers?",
    options: ["1275", "1250", "1300", "1225"],
    correctAnswer: 0,
    category: "Sequences & Series"
  },
  {
    id: 11,
    question: "The height of 20 male workers in a factory is 160cm and the mean height of 30 females in the factory is 155cm. Find the combined mean height of 50 workers.",
    options: ["160", "157", "152", "158"],
    correctAnswer: 1,
    category: "Statistics"
  },
  {
    id: 12,
    question: "Points P(4, 3), Q(6, 4), R(5, 6) and S(3, 5) are the angular points of a quadrilateral, then the quadrilateral is:",
    options: ["Parallelogram", "Rectangle", "Rhombus", "Square"],
    correctAnswer: 3,
    category: "Coordinate Geometry"
  },
  {
    id: 13,
    question: "An observer who is 3 m tall is 45 m away from a pole. The angle of elevation of the top of the pole from his eyes is 45°. The height (in m) of the pole is:",
    options: ["25", "45", "40", "48"],
    correctAnswer: 3,
    category: "Heights & Distances"
  },
  {
    id: 14,
    question: "In how many ways can a pack of 52 cards be equally distributed among 4 players in order?",
    options: ["52!/(13!)⁴", "52!/(13!×4!)", "52!/13!", "52!/13! × 4!"],
    correctAnswer: 0,
    category: "Permutations & Combinations"
  },
  {
    id: 15,
    question: "Two dices are rolled one after the other. The probability that the number on the first is smaller than the number on the second is:",
    options: ["1/2", "5/12", "1/4", "1/12"],
    correctAnswer: 1,
    category: "Probability"
  },
  {
    id: 16,
    question: "What will be arg(z) + arg(z̄) for z ≠ 0?",
    options: ["0", "π", "π/2", "None of these"],
    correctAnswer: 0,
    category: "Complex Numbers"
  },
  {
    id: 17,
    question: "Period of sin²x + cos x is equal to:",
    options: ["π", "2π", "π/2", "Cannot be determined"],
    correctAnswer: 1,
    category: "Trigonometry"
  },
  {
    id: 18,
    question: "What are the maximum number of distinct entries in a lower triangular matrix of order 4?",
    options: ["7", "8", "9", "10"],
    correctAnswer: 3,
    category: "Matrices"
  },
  {
    id: 19,
    question: "Find the ratio in which y-axis divides the line segment joining points (5, -6) and (-1, 4):",
    options: ["2:3", "5:1", "2:5", "3:1"],
    correctAnswer: 1,
    category: "Coordinate Geometry"
  },
  {
    id: 20,
    question: "If p, q, r and s are consecutive terms of an A.P. then what is value of (s² - p²)/(r² - q²)?",
    options: ["0", "3", "9", "None of these"],
    correctAnswer: 1,
    category: "Sequences & Series"
  }
];

export const ndaMathsSet2 = [
  {
    id: 1,
    question: "The angle of elevation of a tower at a level ground is 30°. The angle of elevation becomes θ when moved 15 m towards the tower. If the height of the tower is 10 m, then the value of θ is?",
    options: ["θ = 45°", "θ = tan⁻¹(2/3)", "θ = tan⁻¹(√3/2)", "θ = tan⁻¹((2√3-3)/(2√3-3))"],
    correctAnswer: 3,
    category: "Heights & Distances"
  },
  {
    id: 2,
    question: "Evaluate: sin(21°)cos(69°) + sin(69°)cos(21°)",
    options: ["1", "-1", "0", "None of these"],
    correctAnswer: 0,
    category: "Trigonometry"
  },
  {
    id: 3,
    question: "Two cards are drawn one by one from a pack of cards. The probability of getting first card an ace and second a face card is? (first card is not replaced)",
    options: ["4/52 × 5/51", "5/52", "4/135 × 5/52", "4/221"],
    correctAnswer: 3,
    category: "Probability"
  },
  {
    id: 4,
    question: "From the top of an 8 m high pillar, the angle of elevation of the top of a TV tower is 60° and the angle of depression of its foot is 45°. Find the height of TV tower.",
    options: ["(1+√3) m", "8(1+√5) m", "8(1+√3) m", "5(2+√3) m"],
    correctAnswer: 2,
    category: "Heights & Distances"
  },
  {
    id: 5,
    question: "Two poles are 30 m and 70 m high. The line joining their top makes an angle of 30° with the horizontal. What is the distance between the poles?",
    options: ["40√3", "15√3", "7√3", "6√3"],
    correctAnswer: 0,
    category: "Heights & Distances"
  },
  {
    id: 6,
    question: "If a, b, c, d are in H.P., then:",
    options: ["ab > cd", "ac > bd", "ad > bc", "bc > ad"],
    correctAnswer: 2,
    category: "Sequences & Series"
  },
  {
    id: 7,
    question: "Find the area of the region bounded by the curves y = x² + 2, y = x, x = 0 and x = 3.",
    options: ["23/2 sq. units", "27/2 sq. units", "7/2 sq. units", "1/2 sq. units"],
    correctAnswer: 1,
    category: "Integration"
  },
  {
    id: 8,
    question: "How many numbers between 600 and 1000 can be formed with the digits 3, 5, 7, 8, 9 if no digit is repeated in the same number?",
    options: ["36", "18", "32", "15"],
    correctAnswer: 0,
    category: "Permutations & Combinations"
  },
  {
    id: 9,
    question: "In a school of 300 students, every student reads 5 books and every book is read by 60 students. Find total number of books.",
    options: ["30", "25", "32", "50"],
    correctAnswer: 1,
    category: "Permutations & Combinations"
  },
  {
    id: 10,
    question: "The radius of the circular bubble is increasing at the rate of 0.2 cm/sec. Find the rate of increase of its surface area when the radius is 7cm.",
    options: ["35.2 cm²/sec", "34.2 cm²/sec", "25.6 cm²/sec", "35 cm²/sec"],
    correctAnswer: 0,
    category: "Applications of Derivatives"
  },
  {
    id: 11,
    question: "If AM, GM, and HM are arithmetic mean, geometric mean and harmonic mean of the two numbers respectively, then what will be relation among them?",
    options: ["AM < GM < HM", "AM < HM < GM", "GM < HM < AM", "HM < GM < AM"],
    correctAnswer: 3,
    category: "Sequences & Series"
  },
  {
    id: 12,
    question: "5 years hence, the age of a man shall be 3 times the age of his son while 5 years earlier the age of the man was 7 times the age of his son. The present age of the man is:",
    options: ["45 years", "40 years", "50 years", "47 years"],
    correctAnswer: 1,
    category: "Algebra"
  },
  {
    id: 13,
    question: "Find the sum of an infinite G.P. 4, 1, 1/4, ...?",
    options: ["4/3", "16/3", "Infinite", "None of these"],
    correctAnswer: 1,
    category: "Sequences & Series"
  },
  {
    id: 14,
    question: "In how many ways can 6 examination papers be arranged so that the best and worst papers can never be together?",
    options: ["120", "480", "500", "420"],
    correctAnswer: 1,
    category: "Permutations & Combinations"
  },
  {
    id: 15,
    question: "The tangents of two acute angles are 3 & 2. The sine of twice their difference is:",
    options: ["12/25", "24/25", "7/25", "25/7"],
    correctAnswer: 2,
    category: "Trigonometry"
  },
  {
    id: 16,
    question: "Express 53 in binary system:",
    options: ["110011", "101010", "101110", "110101"],
    correctAnswer: 3,
    category: "Number Systems"
  },
  {
    id: 17,
    question: "The area of the region bounded by the curves y = |x-2|, x = 1, x = 3, and the x-axis is:",
    options: ["4", "2", "3", "1"],
    correctAnswer: 3,
    category: "Integration"
  },
  {
    id: 18,
    question: "What is the rank of identity matrix of order 3×3?",
    options: ["0", "1", "2", "3"],
    correctAnswer: 3,
    category: "Matrices"
  },
  {
    id: 19,
    question: "If the sum of the first 2n terms of the A.P. 2, 5, 8, ... is equal to the sum of the first n terms of the A.P. 57, 59, 61, ..., then n equals:",
    options: ["10", "12", "11", "13"],
    correctAnswer: 2,
    category: "Sequences & Series"
  },
  {
    id: 20,
    question: "In a box containing 100 bulbs, 10 are defective. What is the probability that out of a sample of 5 bulbs none is defective?",
    options: ["(9/10)⁵", "(10/9)²", "10⁻⁵", "(1/10)⁵"],
    correctAnswer: 0,
    category: "Probability"
  }
];

// Combined question bank for random selection
export const allNdaMathsQuestions = [...ndaMathsSet1, ...ndaMathsSet2];

// Function to get random questions for a mock test
export const getRandomQuestions = (count = 10) => {
  const shuffled = [...allNdaMathsQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count).map((q, index) => ({
    ...q,
    id: index + 1
  }));
};

// Categories for filtering
export const categories = [
  "All",
  "Trigonometry",
  "Probability",
  "Sequences & Series",
  "Matrices",
  "Coordinate Geometry",
  "Heights & Distances",
  "Permutations & Combinations",
  "Applications of Derivatives",
  "Integration",
  "Conic Sections",
  "Complex Numbers",
  "Algebra",
  "Statistics",
  "Number Systems"
];
